/**
 * OAuth Configuration
 * Configuration for Google, Microsoft, and Apple OAuth providers
 */

// Google OAuth Configuration
export const GOOGLE_CONFIG = {
  clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
  redirectUri: `${window.location.origin}/auth/google/callback`,
  scope: 'openid profile email',
};

// Microsoft OAuth Configuration  
export const MICROSOFT_CONFIG = {
  clientId: import.meta.env.VITE_MICROSOFT_CLIENT_ID || '',
  authority: `https://login.microsoftonline.com/${import.meta.env.VITE_MICROSOFT_TENANT_ID || 'common'}`,
  redirectUri: `${window.location.origin}/auth/microsoft/callback`,
  scopes: ['openid', 'profile', 'email', 'User.Read'],
};

// Apple OAuth Configuration
export const APPLE_CONFIG = {
  clientId: import.meta.env.VITE_APPLE_CLIENT_ID || '',
  redirectUri: `${window.location.origin}/auth/apple/callback`,
  scope: 'name email',
  responseMode: 'form_post' as const,
  responseType: 'code id_token' as const,
  usePopup: true,
};

// Check which providers are configured
export const OAUTH_PROVIDERS = {
  google: !!GOOGLE_CONFIG.clientId,
  microsoft: !!MICROSOFT_CONFIG.clientId,
  apple: !!APPLE_CONFIG.clientId,
};

export const isOAuthConfigured = () => {
  return Object.values(OAUTH_PROVIDERS).some(configured => configured);
};


